








import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {ILocalVideoTrack} from "agora-rtc-sdk-ng";
import UserIcon from "@share/web-conferences/components/UserIcon.vue";

@Component({
  name: "DeviceTestVideo",
  components: { UserIcon }
})
export default class DeviceTestVideo extends Vue {
  @Prop() videoTrack: ILocalVideoTrack;
  @Prop({default: true}) active: boolean;

  showUserIcon = false;

  get userProfile() {
    return this.$store.getters.profile;
  }

  @Watch('videoTrack')
  onVideoTrackChanged() {
    this.playVideo();
  }

  playVideo() {
    if (this.videoTrack && this.$refs['video'] && !this.videoTrack?.isPlaying && this.active) {
      this.videoTrack?.play(this.$refs['video'] as HTMLElement);
      this.showUserIcon = false;
    }
    else {
      this.showUserIcon = true;
    }
  }

  stopVideo() {
    this.videoTrack?.stop();
    this.showUserIcon = true;
  }

  mounted() {
    this.playVideo();
  }
}
